export const WEB3_GET_PROVIDER = 'WEB3_GET_PROVIDER';
